import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Actions
import { doctorSearch } from '../../../../actions/doctors';

function NameSearch({ setError = () => {} }) {
  const dispatch = useDispatch();
  const [ searchString, setSearchString ] = useState('');
  const [ loading, setLoading ] = useState(false);
  const {
    doctors: {
      selectedZip: zip,
      selectedSpecialty: specialty,
      selectedRadius: radius,
    },
    quote: { cpsID, planYear },
  } = useSelector(store => store);

  function handleInputChange(event) {
    setSearchString(event.target.value);
  }

  function handleSearch(event) {
    event.preventDefault();

    setError('');
    dispatch({ type: 'SET_DOCTORS_SEARCH', payload: [] });

    setLoading(true);
    doctorSearch(zip, searchString, radius, specialty, [cpsID], planYear)
      .then((data) => {
        dispatch({ type: 'SET_DOCTORS_SEARCH', payload: data });
        setLoading(false);
      }).catch(() => {
        setError('Whoops! Something went wrong with the search');
        setLoading(false);
      });
  }

  function handleKeyDown(event) {
    if (event.key === 'Enter') handleSearch(event);
  }

  return (
    <>
      Name
      <div className="row">
        <div className="col-8">
          <input
            id="provider-search-input"
            className="form-control"
            placeholder="e.g. John Smith"
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            value={searchString}
          />
        </div>
        <div className="col-4">
          <button
            type="button"
            id="provider-search-search"
            className="btn btn-primary float-end ms-3 fw-bold"
            style={{ width: '120px' }}
            onClick={handleSearch}
            disabled={loading}
          >
            { loading && <span className="spinner-border spinner-border-sm me-2" /> }
            Search
          </button>
        </div>
      </div>
    </>
  );
}

export default NameSearch;
